import React from "react"
import ReactDOM from "react-dom"
import logger from "./utils/logger"
import createStore from "./store/store"
import config from "./config"
import { Provider } from "react-redux"
import App from "./App"

logger.setLogLevel(config.logLevel)
logger.info("CBRE starting")

const store = createStore(config.ENV, () =>
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById("root")
  )
)



// WEBPACK FOOTER //
// ./src/index.js